import { render, staticRenderFns } from "./CoursePackageList.vue?vue&type=template&id=1f1e166f&scoped=true"
import script from "./CoursePackageList.vue?vue&type=script&lang=js"
export * from "./CoursePackageList.vue?vue&type=script&lang=js"
import style0 from "./CoursePackageList.vue?vue&type=style&index=0&id=1f1e166f&prod&lang=scss&scoped=true"
import style1 from "./CoursePackageList.vue?vue&type=style&index=1&id=1f1e166f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e166f",
  null
  
)

export default component.exports